// packages/api-client/queries/contestsEditionsStandings/index.ts
import { useQuery, useMutation, } from "@tanstack/react-query";
export const createContestsEditionsStandingsQueries = (requests, queryClient) => ({
    useListContestsEditionsStandings: (params, options = {}) => useQuery({
        queryKey: ["contests-editions-standings", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContestsEditionStandings(params);
        },
        ...options,
    }),
    useUpdateContestsEditionsStandings: (options = {}) => useMutation({
        ...options,
        mutationFn: (contestsEditionsStandingsAttrs) => {
            return requests.updateContestsEditionStandings(contestsEditionsStandingsAttrs);
        },
        onSuccess: (...args) => {
            queryClient.invalidateQueries({
                queryKey: ["contests-editions-standings"],
            });
            options.onSuccess?.(...args);
        },
    }),
});
//# sourceMappingURL=index.js.map